import { Button, ContentHeader, HeaderSearchBar } from '@features/ui/components';
import { useMediaQuery } from '@services/hooks/window/query';
import { getRoute } from '@services/routes';
import { useTranslation } from 'next-i18next';

export const PatientsContentHeader = (): JSX.Element => {
  const { t } = useTranslation('common');

  const autoFocus = useMediaQuery('md');

  const className = 'max-sm:flex-grow max-sm:shrink-0 max-sm:basis-auto';

  const rightContentHeader = (
    <div className="flex gap-3 max-sm:flex-wrap-reverse">
      <HeaderSearchBar autoFocus={autoFocus} className={className} />
      <Button
        className={className}
        label={t<string>('pages.patients.contentHeader.buttonNewOrder')}
        variant="primary"
        leftIcon="inbox"
        url={getRoute.orderNew().pathname}
      />
    </div>
  );

  return (
    <ContentHeader
      title={t('pages.patients.contentHeader.title')}
      upperTitle={t('pages.patients.contentHeader.upperTitle')}
      rightElement={rightContentHeader}
    />
  );
};
